import { useMeQuery } from "@/queries/queries";
import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import React from "react";
import { Header } from "../shared/ui/text";
import { usePortalReturnMode } from "@/components/portal/PortalReturnBar";

interface SiteHeaderProps {
  /**
   * Optional. When the underlying page already renders its own ``<h1>``
   * — Dashboard, BuildingsList — DO NOT pass this prop, otherwise the
   * title duplicates (an ``<h2>`` here and an ``<h1>`` inside the page).
   * Pass it only for pages that don't render their own page title
   * (Settings, BuildingDetail).
   */
  header?: string;
  backLink?: string;
}
const SiteHeader: React.FC<SiteHeaderProps> = ({
  header,
  backLink,
}: SiteHeaderProps) => {
  const { data } = useMeQuery();
  const displayUser = data?.firstName
    ? `${data.firstName} ${data.lastName}`
    : data?.email;
  // In portal-return mode the global PortalReturnBar at the top of the page
  // already provides the only relevant back affordance ("Back to Tracker").
  // SiteHeader's local back arrow would just point at another Classic page,
  // which is confusing — hide it.
  const isPortalReturn = usePortalReturnMode();
  const showBack = backLink && !isPortalReturn;
  return (
    <div className="flex px-10 py-4 border-b border-gray-300 justify-between items-center">
      <div className="flex items-center gap-4">
        {showBack && (
          <Link to={backLink}>
            <ArrowLeft size={16} />
          </Link>
        )}
        {header && <Header>{header}</Header>}
      </div>
      <div className="flex items-center gap-3">
        <Link to="/settings">{displayUser}</Link>
      </div>
    </div>
  );
};

export default SiteHeader;
